import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get, intersection, isEmpty } from 'lodash';
import Tabs from 'kepler/lib/components/Tabs';
import { MARKETPLACES, MISC } from '../lib/constants';
import DefaultCategoriesContent from './DefaultCategoriesContent';
import getContent from '../lib/dictionaryFetcher';
import { checkForEmptyCategory } from '../lib/helpers';

/**
 * render all the categories for desktop or laptop screensize.
 * @param {*} props
 */
const DefaultCategories = props => {
  const {
    activeKey,
    categories,
    favorites,
    changeTab,
    featured,
    categoryIndexes,
    experimentation,
    tools
  } = props;

  /**
   * render panel with cards.
   *
   * @param {string} title
   * @param {int} index
   * @param {object} category
   * @param {string} heading
   */

  let newLabel = getContent('merchanthub', 'categories.label.new', '');

  const renderTabPane = (tabTitle, title, index, category) => {
    const activeCategory = Object.keys(categoryIndexes).find(
      key => categoryIndexes[key] === activeKey
    );

    return (
      <Tabs.TabPane tab={tabTitle || title} key={index}>
        {activeCategory === get(category, 'name', '') && (
          <DefaultCategoriesContent
            {...props}
            title={title}
            category={category}
          />
        )}
      </Tabs.TabPane>
    );
  };

  const categoryTabs = categories.map((category, index) => {
    let categoryName = get(category, 'name', ''),
      title = getContent('merchanthub', `categories.${categoryName}`, ''),
      tabTitle = title,
      items = get(category, 'items', []),
      newCategories = [MISC.SELLING, MISC.SHOPPING_CARTS],
      isNewCategories = newCategories.includes(categoryName),
      hasMarketplaces =
        !isEmpty(featured) || intersection(items, MARKETPLACES).length > 0,
      isEmptyCategory =
        checkForEmptyCategory(category, tools) &&
        (!isNewCategories || !hasMarketplaces),
      isNotInDiscoverExperience =
        categoryName === MISC.DISCOVER &&
        !get(experimentation, MISC.DISCOVER, false),
      isNotInMarketplacesExperience =
        categoryName === MISC.SHOPPING_CARTS &&
        !get(experimentation, MISC.MARKETPLACES, false);

    if (
      isEmptyCategory ||
      isNotInDiscoverExperience ||
      isNotInMarketplacesExperience
    ) {
      return null;
    } else if (categoryName === MISC.FAVORITES) {
      category.items = favorites;
    } else if (isNewCategories && hasMarketplaces && newLabel.length) {
      tabTitle = (
        <Fragment>
          {tabTitle}
          <span className="myapps-tab-new">{newLabel}</span>
        </Fragment>
      );
    }

    return renderTabPane(tabTitle, title, index, category);
  });

  const onTabClick = key => {
    // Our tools tab does not trigger `changeTab` when clicking on the same category
    // this becomes an issue when user searches something and then click on the active tab.
    // In order to overcome this, we need to use to the `onTabClick` callback and trigger
    // the clear search link click manually.
    const clearSearchLink = document.getElementById('clear-search-link');
    if (clearSearchLink && key === activeKey) {
      clearSearchLink.click();
    }
  };

  return (
    <Tabs
      activeKey={activeKey}
      defaultActiveKey="0"
      onChange={changeTab}
      onTabClick={onTabClick}
      tabPosition="left"
    >
      {categoryTabs}
    </Tabs>
  );
};

DefaultCategories.propTypes = {
  app: PropTypes.object,
  categories: PropTypes.array,
  categoryIndexes: PropTypes.object,
  favorites: PropTypes.array,
  activeKey: PropTypes.string,
  toggleFavorite: PropTypes.func,
  setApp: PropTypes.func,
  setTool: PropTypes.func,
  changeTab: PropTypes.func,
  tools: PropTypes.object,
  search: PropTypes.object,
  recordClick: PropTypes.func,
  tracking: PropTypes.object,
  recommendations: PropTypes.array,
  featured: PropTypes.object,
  experimentation: PropTypes.object
};

export default DefaultCategories;
